<template>
  <event-management
    :get-applications="getApplications"
    :get-categories="getCategories"
    :get-event="getEvent"
    :get-roles="getRoles"
    :save-event="saveEvent"
    :update-event="updateEvent"
  />
</template>

<script>
import { EventManagement } from 'operations';
import {
  fetchRol,
  fetchCategory,
  fetchEventById,
  saveEvent as _saveEvent,
  updateEvent as _updateEvent,
} from '@/modules/operations/api';

import { getApplications } from '@/modules/shared/code.api';

export default {
  name: 'EventManagementWrapper',
  components: { EventManagement },
  methods: {
    getRoles() {
      return fetchRol();
    },
    getCategories() {
      return fetchCategory();
    },
    getEvent(id) {
      return fetchEventById(id);
    },
    saveEvent(params) {
      return _saveEvent(params);
    },
    updateEvent(params) {
      return _updateEvent(params);
    },
    getApplications() {
      return getApplications();
    },
  },
};
</script>
